import classNames from "classnames";
import { InputText } from "primereact/inputtext";
import { KeyboardEventHandler } from "react";
import { Controller, FieldValues } from "react-hook-form";

import { FormControllerProp } from "../../shared/ui/hook-form/form-controller-prop.interface";
import FormError from "../../shared/ui/hook-form/form-error/form-error";

export type InputControlType = "text" | "digit" | "password" | "date";
interface InputControlProps<FieldsType extends FieldValues>
  extends FormControllerProp<FieldsType> {
  label?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  type?: InputControlType;
  disabled?: boolean;
  hint?: string;
  iconRight?: string;
  iconRightAction?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
}

export function PreviewInputControl<FieldsType extends FieldValues>({
  rules,
  label,
  control,
  name,
  placeholder,
  className,
  containerClassName,
  type,
  disabled,
  hint,
  iconRight,
  iconRightAction,
  onKeyDown,
}: InputControlProps<FieldsType>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        // <div className={classNames(containerClassName, "my-0 py-0")}>
        <input
          className={classNames("px-1 py-0", className)}
          type={type}
          id={field.name}
          value={field.value}
          placeholder={placeholder}
          onChange={(e) => field.onChange(e.target.value)}
          disabled={disabled}
          onKeyDown={onKeyDown}
        />
        // </div>
      )}
    />
  );
}

export default PreviewInputControl;
